import React from "react";
import LegalLayout from "./ui/LegalLayout";

const SECTIONS = [
  {
    title: "Acceptance of Terms",
    body: (
      <p>
        By accessing or using AgriHyphen AI, you agree to these Terms of Use.
      </p>
    ),
  },
  {
    title: "Use of Uploaded Images",
    body: (
      <p>
        When you upload images to the application, you grant AgriHyphen AI a
        non-exclusive, worldwide, royalty-free licence to store, process, and
        use those images to improve our AI models and services, including
        research and development. Where feasible, data will be anonymised.
      </p>
    ),
  },
  {
    title: "Prohibited Uses",
    body: (
      <p>
        You agree not to misuse the service, including attempting to upload
        unlawful content or using the system in ways that could harm other users
        or the service.
      </p>
    ),
  },
  {
    title: "Disclaimer",
    body: (
      <p>
        AgriHyphen AI provides recommendations for informational purposes and
        does not replace professional agronomic advice. You are responsible for
        decisions made based on outputs from the app.
      </p>
    ),
  },
  {
    title: "Limitation of Liability",
    body: (
      <p>
        To the maximum extent permitted by law, AgriHyphen AI is not liable for
        indirect, incidental, or consequential damages arising from the use of
        the service.
      </p>
    ),
  },
  {
    title: "Changes to These Terms",
    body: (
      <p>
        We may update these terms from time to time. Continued use of the
        service after changes constitutes acceptance of the updated terms.
      </p>
    ),
  },
  {
    title: "Contact",
    body: (
      <p>
        For questions about these terms, contact{" "}
        <a href="mailto:contact@hyphentech.africa">AgriHyphen AI support</a>.
      </p>
    ),
  },
];

export default function TermsOfUse() {
  return (
    <LegalLayout
      title="Terms of Use"
      updated="15 October 2025"
      sections={SECTIONS}
    />
  );
}
